<app-header-title>
  <span title>{{'hr.EmployeeAttachment' |translate}}</span>
</app-header-title>


<div id="data-grid-demo">
  <div class="publicsetting" style="padding: 0rem 3rem;">
    <dx-data-grid #grid class="dx-card wide-card" [dataSource]="allemployeeAttacment" [showBorders]="false"
      [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
      [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
      [showBorders]="false" [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false"
      (onInitNewRow)="goToAddAttachment($event)" (onEditingStart)="goToAddAttachment($event)">
      <dxo-paging [enabled]="false"></dxo-paging>
      <dxo-editing mode="row" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
      </dxo-editing>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxi-column dataField="notes" caption="{{'hr.notes' |translate }}">
      </dxi-column>
      <dxi-column dataField="createdOnDate" caption="تــاريــخ الإنــشــاء">
      </dxi-column>
      <dxi-column dataField="createdOnTime" caption="وقـــت الإنــشــاء">
      </dxi-column>
      <dxi-column dataField="branchName" caption="إســـم الــفــرع">
      </dxi-column>
      <dxi-column dataField="userName" caption="إســـم الـمـســتـخـدم">
      </dxi-column>

      <dxi-column dataField="fileUrl" [width]="100" [allowFiltering]="false" [allowSorting]="false"
        caption="{{'cdc.image'|translate}}" cellTemplate="cellTemplate"></dxi-column>
      <dxi-column dataField="employeeId" caption="{{'hr.employeeId'|translate}}">
        <dxo-lookup [dataSource]="employeeMenu" valueExpr="id"
          [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column>
      <dxi-column dataField="employeeAttachmentTypeId" caption="{{'hr.EmployeeAttachmentTypes'|translate}}">
        <dxo-lookup [dataSource]="AttacmentMenu" valueExpr="id"
          [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column>
      <!-- <dxi-column dataField="fileUrl" caption="{{'hr.fileUrl' |translate}}" [width]="70">
    </dxi-column> -->
      <dxi-column type="buttons">
        <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
        <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
      </dxi-column>

      <div *dxTemplate="let data of 'cellTemplate'">
        <img *ngIf="!data.value.toLocaleLowerCase().includes('.pdf')" [src]="data.value" alt="Picture of {{ data.data.FirstName }} {{ data.data.LastName }}" width="40"
          height="40" style="object-fit: cover; border-radius: 5px;" (click)="openImage(data)" />

          <div *ngIf="data.value.toLocaleLowerCase().includes('.pdf')">
        <button class="btn btn-primary" (click)="openImage(data)">عــرض</button>
      </div>

      </div>
    </dx-data-grid>
  </div>